import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';

import { MdOutlineLanguage } from 'react-icons/md';
import { useAppDispatch } from '@wajeez-web/stores/base';
import { CommonActions, useCommonSelector } from '@wajeez-web/stores/common';

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ');
}

type local = 'ar' | 'en';

const languageNavigation = [
  {
    name: 'English',
    value: 'en' as local,
    href: '',
  },
  {
    name: 'Arabic',
    value: 'ar' as local,
    href: '',
  },
];

const LanguageViewMenu: React.FC = () => {
  const dispatch = useAppDispatch();

  const { lang } = useCommonSelector((state) => state.common.settings);

  const getIcon = () => {
    switch (lang) {
      case 'ar':
        return (
          <div className="flex justify-center items-center">
            <MdOutlineLanguage className="xl:h-6 xl:w-6 lg:w-5 lg:h-5 md:w-4 md:h-4  text-textSecondary" />
            <div className="ms-2">AR</div>
          </div>
        );
      case 'en':
        return (
          <div className="flex justify-center items-center">
            <MdOutlineLanguage className="xl:h-6 xl:w-6 lg:w-5 lg:h-5 md:w-4 md:h-4  text-textSecondary" />
            <div className="ms-2">EN</div>
          </div>
        );
    }
  };

  const onSelect = (val: local) => {
    dispatch(CommonActions.setLang(val));

    window.location.reload();
  };

  return (
    <Menu as="div" className="relative z-50">
      {({ open }) => (
        <>
          <div>
            <Menu.Button className="flex items-center text-sm rounded-full focus:outline-none">
              <span className="sr-only">Open language menu</span>
              <div className="">{getIcon()}</div>
            </Menu.Button>
          </div>
          <Transition
            show={open || false}
            as={Fragment}
            key={1 + 'view'}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className={`origin-top-left absolute ltr:right-0 rtl:left-0 mt-2 w-52 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none`}
            >
              <div className="py-2">
                {languageNavigation.map((item) => {
                  return (
                    <Menu.Item key={item.name}>
                      {({ active }) => (
                        <div
                          onClick={() => {
                            onSelect(item.value);
                          }}
                          className={classNames(
                            active ? 'bg-gray-100' : '',
                            'group flex items-center px-4 py-2 text-sm text-gray-700 cursor-pointer'
                          )}
                        >
                          {item.name}
                        </div>
                      )}
                    </Menu.Item>
                  );
                })}
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};

export default LanguageViewMenu;
